'use client';

import style from './Header.module.scss';
import Image from 'next/image';
import { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAppSelector } from '@/store/hook';

// icons
import { IconMenu, IconAddFriendOutline } from '@/components/icons';

// 元件
import Avatar from '@/components/ui/avatar/Avatar';
import HeaderMenuMoreDropdown from './HeaderMenuMoreDropdown';
import SearchModal from '@/components/search/SearchModal';

// const
import { DEFAULT_AVATAR } from '@/constants/image';

const Header = () => {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const menuRef = useRef<HTMLLIElement>(null);
  const pathName = usePathname();
  const meInfo = useAppSelector((state) => state.auth.meInfo);

  // 隱藏 header on scroll down
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY > lastScrollY && currentY > 300) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
      setLastScrollY(currentY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Menu icon dropdown
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && e.target instanceof Node && !menuRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  return (
    <header className={`${style.header} ${!showHeader ? style.hidden : ''}`}>
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <Link href="/" className={style.logoWrapper}>
            <Image
              src="https://d1q14jmvwk39e0.cloudfront.net/public/assets/images/logo.png"
              alt="WOMO"
              fill
              className={style.logoImage}
              loading="eager"
            />
          </Link>

          <ul className="d-none d-lg-flex align-items-center justify-content-between">
            <li>
              <Link
                href="/"
                className={`d-flex align-items-center NavLinkIcon ${style.headerNavLink} ${
                  pathName === '/' ? 'active text-brand' : ''
                }`}
              >
                <span className="icon iconHome" />
                <span className="ms-1">探索AR</span>
              </Link>
            </li>

            <li>
              <Link
                href="/me/profile"
                className={`d-flex align-items-center NavLinkIcon ${style.headerNavLink} ${
                  pathName === '/user/my_profile' ? 'active text-brand' : 'text-dark'
                }`}
              >
                <span className={style.avatar}>
                  <Avatar src={meInfo?.u_photo ?? DEFAULT_AVATAR} size={32} />
                </span>
              </Link>
            </li>

            <li>
              <Link
                href="/me/wallet"
                className={`d-flex align-items-center NavLinkIcon ${style.headerNavLink} ${
                  pathName === '/user/coin_wallet' ? 'active text-brand' : ''
                }`}
              >
                <span className="icon iconWallet" />
                <span className="ms-1">籌碼包</span>
              </Link>
            </li>
            {/* <li>
              <Link
                href="/me/profile-green-coin"
                className={`d-flex align-items-center NavLinkIcon ${style.headerNavLink} ${
                  pathName === '/me/profile-green-coin' ? 'active text-brand' : ''
                }`}
              >
                <span className="icon iconWe" />
                <span className="ms-1">我們倆</span>
              </Link>
            </li>
            <li>
              <Link
                href="/me/profile-red-coin"
                className={`d-flex align-items-center NavLinkIcon ${style.headerNavLink} ${
                  pathName === '/me/profile-red-coin' ? 'active text-brand' : ''
                }`}
              >
                <span className="icon iconIncome" />
                <span className="ms-1">玩斜槓</span>
              </Link>
            </li> */}
          </ul>

          {/* funcBtn */}
          <ul className={`d-flex py-3 ${style.headerNavUtility}`}>
            {meInfo ? (
              <li>
                <Link href="/me/coin-friends?isChangeToAddFriend=true" className={style.funcBtn}>
                  <IconAddFriendOutline width={24} />
                </Link>
              </li>
            ) : null}
            <li>
              <SearchModal />
            </li>
            <li className="nav-item dropdown" ref={menuRef}>
              <button
                onClick={toggleDropdown}
                className="btn p-0 border-0"
                aria-expanded={isDropdownOpen}
                aria-haspopup="true"
              >
                <IconMenu width={24} />
              </button>

              {isDropdownOpen && <HeaderMenuMoreDropdown />}
            </li>
          </ul>

          {/* <li>
                <Link href="/me/notification" className="position-relative">
                  <IconBell width={24} />
                  <span className="position-absolute top-0 end-0 translate-middle p-1 bg-danger border border-light rounded-circle">
                    <span className="visually-hidden">新通知</span>
                  </span>
                </Link>
              </li>
            */}
        </div>
      </div>
    </header>
  );
};

export default Header;
